<template>
  <div id="bodyMain">
    <div id="container">
      <div style="width: 100%; padding-top: 120px;position: absolute;">
        <div class="main">
          <div style="width: 100%;height: 130px;">
            <div style="float: left;width: 40%;text-align: center;">
              <img src="@/assets/sylogo.png" width="127" height="127" style="border-radius: 63px;" />
            </div>
            <div style="float: left;width: 60%;padding-top: 20px;">
              <h1><span>服务共享平台</span></h1>
            </div>
          </div>
          <BR/>
          <div style="width:100%;height: 50px; margin: 0 auto;">
            <div style="float: left;width: 15%; text-align: right; line-height: 35px;">&nbsp;</div>
            <div style="float: left;width: 85%;text-align: left;"><!--<img src="@/assets/login1.png" class="img1" />--><input type="text" class="text" id="user" placeholder="请输入登录账号"/></div>
          </div>
          <BR/>
          <div style="width:100%;height: 50px; margin: 0 auto;">
            <div style="float: left;width: 15%; text-align: right; line-height: 35px;">&nbsp;</div>
            <div style="float: left;width: 85%;text-align: left;"><!--<img src="@/assets/login2.png"  class="img1" />--><input type="password" class="text" id="pwd" placeholder="请输入登录密码" /></div>
          </div>
          <BR/>
          <div style="width:100%;height: 50px; margin: 0 auto;">
            <div style="float: left;width: 15%; text-align: right; line-height: 35px;">&nbsp;</div>
            <div style="float: left;width: 55%;text-align: left;"><!--<img src="@/assets/login3.png"  class="img1" />--><input type="text" class="text1" id="checkNum" maxlength="4" placeholder="请输入验证码" /></div>
            <div style="float: left;width: 25%;text-align: left;"><span id="checkCode" @click="createCode()" style='color:Green; background-image:url(img/ybg.png);font-size:26px;border:solid 1px #cccccc; width: 100px;cursor: pointer;'>{{code}}</span></div>
          </div>
          <br/>
          <div style="width: 100%;">
            <div class="loginbutton" @click="validate()"><span id="dl">登录</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Victor from '@/assets/vector.js'
  import Vue from 'vue'
  export default {
    name: 'login',
    data(){
      return{
        code:"",
        out:"",
      }
    },
    methods:{
      createCode:function () {
        var code = "";
        var codeLength = 4;//验证码的长度
        var random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','s','y','z');//随机数
        for(var i = 0; i < codeLength; i++) {//循环操作
          var index = Math.floor(Math.random()*random.length);//取得随机数的索引（0~35）
          code += random[index];//根据索引取得随机数加到code上
        }
        this.code = code;//把code值赋给验证码
      },
      setCookie(c_name, value, expiredays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + expiredays);
        document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
      },
      validate:async function () {
        var inputCode = document.getElementById("checkNum").value.toUpperCase();
        var user = document.getElementById("user").value;
        var pwd = document.getElementById("pwd").value;
        if (user.length <= 0) {
          this.$message({
            message: '请输入账号',
            type: 'warning'
          });
        }
        else if (inputCode.length <= 0) {
          this.$message({
            message: '请输入验证码',
            type: 'warning'
          });
        }
        else if (inputCode != (this.code).toUpperCase()) {
          this.$message({
            message: '验证码输入错误',
            type: 'warning'
          });
          this.createCode();
        }
        else {
          document.getElementById("dl").innerHTML = "登录中...";
          await this.$axios.post('/api/validateLogon',{
            'username':user,
            'password':pwd
          }).then((response,err) => {
            response = response.data;
            if(!err){
              if(response.code == "Fail"){
                this.$message({
                  message: response.message,
                  type: 'warning'
                });
              }else if(response.code == "Success"){
                this.$message({
                  message: response.message,
                  type: 'success'
                });
                //设置cookie
                this.setCookie("dataPlatformID",response.data,null);
                this.$nextTick (function () {
                  location.href = "/main"
                })
              }else if(response.code == "WhiteList"){
                this.$message({
                  message: response.message,
                  type: 'warning'
                });
              }else{
                this.$message({
                  message: '登录异常',
                  type: 'warning'
                });
              }
              document.getElementById("dl").innerHTML = "登录";
            }else{
              this.$message({
                message: '登录异常',
                type: 'warning'
              });
            }
          });
        }
      },
      zx:function () {
        //清楚登录状态
      }
    },
    mounted:function () {
      this.out = this.$route.query.out?this.$route.query.out:"";
      if(this.out==1){
        this.zx();
      }
      Victor("bodyMain", "container");   //登陆背景函数
    },
    created: function() {
      var _this = this;
      document.onkeydown = function(e) {
        let key = window.event.keyCode;
        if (key == 13) {
          _this.validate();
        }
      };
      this.createCode();
    }
  }
</script>
<style scoped>
  #bodyMain{width:100%;height:100%;position:fixed;top:0;left:0;z-index:999}
  #container{width:100%;height:100%}
  span{
    font-family: 思源黑体;
  }
  .main{
    width: 500px; height: 450px;margin: 0 auto;border:solid 1px #EAEAEA;border-radius: 3px;padding-top: 20px;
    background-color: #ffffff;border-radius: 8px;box-shadow: #fff 0px 0px 10px;
  }
  .text{
    height: 40px;
    width: 330px;
    vertical-align:middle;
    border-radius: 20px;
    border: 1px #EDEDED solid;
    text-indent: 10px;
  }
  .text1{
    height: 40px;
    width: 230px;
    vertical-align:middle;
    border-radius: 20px;
    border: 1px #EDEDED solid;
    text-indent: 10px;
  }
  .font1{
    font-size: 18px;
    color: #777878;
  }
  .img1{
    vertical-align: middle;
    width: 36px;height: 36px;
  }
  .loginbutton{
    cursor: pointer;width: 300px;height: 40px;background-color: #017AAF;text-align: center;color: #ffffff;margin: 0 auto;line-height: 40px;
    border-radius: 20px;
    margin-top: 10px;
  }
  #bodyMain canvas{
    position: fixed !important;
    width: 100% !important;
    height: 100% !important;
    top:0;left: 0;right: 0;bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue